import React from 'react'
import {
  Box,
  BoxProps,
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { RestrictionTypeList, RestrictionTypeListId } from 'src/api'
import { FieldValues, useController, UseControllerProps } from 'react-hook-form'

interface Props<T extends FieldValues>
  extends Omit<BoxProps, 'defaultValue' | 'onChange'>,
    UseControllerProps<T> {
  restrictionTypeList: RestrictionTypeList[]
  onChange?: (val: RestrictionTypeListId | undefined) => void
}

const RestrictionTypeSelector = <T extends FieldValues>({
  restrictionTypeList,
  control,
  name,
  defaultValue,
  rules,
  shouldUnregister,
  onChange,
  ...restBoxProps
}: Props<T>) => {
  const { t } = useTranslation()
  const {
    field: { ref, onChange: onFormChange, ...field },
    fieldState: { error }
  } = useController({
    control: control,
    name,
    defaultValue,
    rules,
    shouldUnregister
  })

  return (
    <Box {...restBoxProps}>
      <Typography
        sx={{
          fontWeight: 600
        }}
      >
        {t('form.titles.Select_the_type_of_restriction_you_want_to_stablish')}
      </Typography>
      <FormControl error={!!error}>
        <Select
          placeholder={t('labels.Restriction')}
          sx={{ marginTop: '1rem', minWidth: '10rem' }}
          onChange={(e) => {
            onFormChange(e)
            onChange?.(e.target.value as RestrictionTypeListId | undefined)
          }}
          {...field}
          inputRef={ref}
        >
          {restrictionTypeList.map(({ id, name }) => (
            <MenuItem key={id} value={id}>
              {name}
            </MenuItem>
          ))}
        </Select>
        {error?.message && <FormHelperText>{error.message}</FormHelperText>}
      </FormControl>
    </Box>
  )
}
export default RestrictionTypeSelector
